function tabThroughAttr(){
    /* скрипт сделан именно так ибо предусмотрена возможность того, что элементы не будут сиблингами */
    $(document).on('click', '.w-tab-attr', function(){
        var targetAttr = $(this).attr('data-tab-attr');
        var target = $('.w-tab-attr-item[data-tab-attr="' + targetAttr + '"]');
        $('body')
        .find(target)
        .closest('.w-tab-attr-items-wrap')
        .find('.w-tab-attr-item')
        .removeClass('active');

        target.addClass('active')
    });
}
$(document).ready(function(){
    tabThroughAttr();
});